<template>
    <ul class="breadcrumb">
    <li>
        <router-link :to="{name: 'home'}">Home</router-link>
    </li>
    <li v-for="link in links" :key="link.title">
        <router-link :to="link.to">{{ link.title }}</router-link>
    </li>
</ul>
</template>

<script>
export default {
    props: {
        links: {
            type: Array,
            default: () => []
        }
    }
}
</script>

<style>

</style>
